import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';
import Newsletter from './Newsletter';

const footerLinks = {
  OPINIGURU: [
    ['About', '/about'],
    ['Contact', '/contact'],
    ['Advertise', '/contact'],
    ['Careers', '/contact']
  ],
  SECTIONS: [
    ['News', '/news'],
    ['Asia', '/asia'],
    ['Europe', '/europe'],
    ['Sport', '/sport'],
    ['Business', '/business'],
    ['Technology', '/technology'],
    ['Health', '/health'],
    ['Culture', '/culture'],
    ['Arts', '/arts'],
    ['Travel', '/travel'],
    ['Earth', '/earth']
  ],
  LEGAL: [
    ['Privacy Policy', '/privacy'],
    ['Terms & Conditions', '/terms'],
    ['Cookie Policy', '/privacy'],
    ['Editorial Policy', '/editorial-policy']
  ]
};

function Footer() {
  return (
    <>
      <div className="shell">
        <Newsletter />
      </div>

      <footer className="footer">
        <div className="shell footer-grid">
          <div className="footer-brand">
            <Brand footer />
            <p>
              Independent reporting, informed analysis and ideas that
              clarify a changing world.
            </p>
            <div className="socials">
              <a>Facebook</a>
              <a>Instagram</a>
              <a>X</a>
              <a>YouTube</a>
              <a>LinkedIn</a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div className="footer-column" key={title}>
              <h4>{title}</h4>
              {links.map(([label, path]) => (
                <Link key={label} to={path}>
                  {label}
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className="shell footer-bottom">
          <span>© 2026 Opiniguru. All rights reserved.</span>
          <span>News. Views. Perspective.</span>
        </div>
      </footer>
    </>
  );
}

export default Footer;